import moment from 'moment';

export function request(customerId, name, conditions) {
    customerId = parseInt(customerId, 10);

    if (conditions && conditions.startDate) {
        conditions.startDate = moment(conditions.startDate).format('YYYY-MM-DDT00:00:00');
    }

    if (conditions && conditions.endDate) {
        conditions.endDate = moment(conditions.endDate).format('YYYY-MM-DDT23:59:59');
    }

    return {
        type: 'CUSTOMERS_GET_FREEBET_HISTORY_REQUEST',
        customerId,
        name,
        conditions
    };
}

export function error(customerId, name, errors) {
    customerId = parseInt(customerId, 10);

    return {
        type: 'CUSTOMERS_GET_FREEBET_HISTORY_ERROR',
        errors,
        customerId,
        name
    };
}

export function finish(customerId, name, history) {
    return {
        type: 'CUSTOMERS_GET_FREEBET_HISTORY_FINISH',
        history,
        customerId,
        name
    };
}

export function clear() {
    return {
        type: 'CUSTOMERS_GET_FREEBET_HISTORY_CLEAR'
    };
}
